import { render } from "./DeactiveConfirmModal.vue?vue&type=template&id=4ab763b2"
import script from "./DeactiveConfirmModal.vue?vue&type=script&lang=js"
export * from "./DeactiveConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__